<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        <div class="flex">
          <!-- <div class="box flex">
            <div class="title">核销方式：</div>
            <el-select
              v-model="is_cancle"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
          <div class="box flex">
            <div class="title">是否使用：</div>
            <el-select
              clearable
              v-model="is_used"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
            >
              <el-option
                v-for="item in useStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="box flex">
            <div class="title">领取方式：</div>
            <el-select
              clearable
              v-model="get_type"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
<!--          <div class="box flex" v-if="!pageStatus">-->
<!--            <div class="title">券类型：</div>-->
<!--            <el-select-->
<!--              clearable-->
<!--              v-model="type"-->
<!--              placeholder="请选择"-->
<!--              size="small"-->
<!--              class="fixedwidth"-->
<!--            >-->
<!--              <el-option-->
<!--                v-for="item in ticketOption"-->
<!--                :key="item.value"-->
<!--                :label="item.name"-->
<!--                :value="item.value"-->
<!--              >-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
          <div class="box flex">
            <div class="title">券名称：</div>
            <el-select
              clearable
              v-model="couponName"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
              :disabled="pageStatus"
            >
              <el-option
                v-for="item in couponData"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex">
<!--          <div class="box flex">-->
<!--            &lt;!&ndash; <div class="title">券名称：</div> &ndash;&gt;-->
<!--            &lt;!&ndash; <el-input-->
<!--              style="width: 180px"-->
<!--              size="small"-->
<!--              v-model="title"-->
<!--            ></el-input> &ndash;&gt;-->
<!--            <el-radio-group-->
<!--              v-model="statistics"-->
<!--              size="small"-->
<!--              @change="radiogroup"-->
<!--            >-->
<!--              <el-radio-button-->
<!--                :label="item.value"-->
<!--                v-for="(item, index) in timeType"-->
<!--                :key="index"-->
<!--                >{{ item.name }}</el-radio-button-->
<!--              >-->
<!--            </el-radio-group>-->
<!--          </div>-->
          <div class="box flex">
            <div class="title">券有效期：</div>
            <el-date-picker
              style="width: 390px;"
              v-model="dateValue"
              size="small"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
          <div class="box flex">
            <div class="title"></div>
            <el-button type="primary" size="small" @click="screen"
              >筛选</el-button
            >
            <el-button size="small" @click="exportList">导出</el-button>
          </div>
        </div>
        <div class="show">
          <el-card
            class="box-card"
            shadow="hover"
            v-for="(item, index) in cardData"
            :key="index"
          >
            <div>{{ item.name }}</div>
            <div>
              <div class="">
                <span class="num">
                  {{ item.use1 }}
                </span>
                {{ item.unit }}
              </div>
            </div>
          </el-card>
        </div>
        <div class="box flex">
          <el-button
            v-for="(item, index) in optionData"
            :key="index"
            type="primary"
            :icon="item.icon"
            size="small"
            @click="go(item.value)"
          >
            {{ item.name }}
          </el-button>
        </div>
      </div>
      <div class="bottom">
        <el-table
          :data="tableData"
          size="small"
          :header-cell-style="setHeader"
          @selection-change="handleSelectionChange"
          height="100%"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="title" label="券名称"></el-table-column>
          <el-table-column label="券类型" prop="coupon"> </el-table-column>
          <el-table-column prop="exp" label="是否过期" >
          </el-table-column>
<!--          <el-table-column prop="used" label="是否使用" >-->
<!--          </el-table-column>-->
          <el-table-column prop="isShop" label="优惠券状态" >
          </el-table-column>
          <el-table-column prop="use_time" label="核销时间" width="140"></el-table-column>
          <el-table-column prop="get_time" label="领取时间" width="140"></el-table-column>
          <el-table-column prop="start_time" label="有效期开始时间" width="140"></el-table-column>
          <el-table-column prop="end_time" label="有效期结束时间" width="140"></el-table-column>
          <el-table-column prop="is_cancle" label="核销场景">
            <template slot-scope="scope">
              <div v-if="scope.row.is_cancle == 0">线上</div>
              <div v-if="scope.row.is_cancle == 1">扫码核销</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="" label="消费产品"></el-table-column>
          <el-table-column prop="" label="消费金额"></el-table-column> -->
          <el-table-column
            prop="info.real_name"
            label="会员名"
          ></el-table-column>
          <el-table-column prop="info.mobile" label="电话" width="100"></el-table-column>
          <el-table-column prop="employee.name" label="操作人">
            <template slot-scope="scope">
              <div v-if="scope.row.is_cancle == 0">
                <el-button type="text">用户本人</el-button>
              </div>
              <div v-if="scope.row.is_cancle == 1">
                <el-button type="text">{{ scope.row.employee.name }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <div class="rowOption">
                <el-button
                  size="small"
                  v-if="scope.row.is_stop == 1"
                  @click="shop(0, scope.row.id)"
                >
                  开启用券
                </el-button>
                <el-button size="small" v-else @click="shop(1, scope.row.id)">
                  暂停用券
                </el-button>
                <el-button
                  v-if="scope.row.is_used == 0 && scope.row.is_exp == 0"
                  size="small"
                  @click="postPhone(scope.row)"
                >
                  延期用券
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next, jumper"
          :total="total_num"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 延期 -->
    <el-dialog
      title="延期"
      :visible.sync="showTime"
      @close="closePostPhone"
      width="580px"
    >
      <el-form ref="form" :model="postponeForm" label-width="120px">
        <!-- <el-form-item label="优惠券">
          <el-tag
            v-for="(item, index) in multipleSelection"
            :key="index"
            style="margin-right:10px"
          >
            {{ item.title }}
          </el-tag>
        </el-form-item> -->
        <el-form-item label="请重新选择时间">
          <el-date-picker
            class="marginRL"
            size="small"
            v-model="postponeForm.date1"
            value-format="yyyy-M-d"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePostPhone">取 消</el-button>
        <el-button type="primary" @click="confirmPostPhone">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { coupon_indexs, couponCancle_expser, couponList, couponPostponeUser, couponShopUser } from "@/api/coupon";
import { exportMethod } from "@/api/vip";
import { time } from "@/utils/public";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      loading: false,
      is_used: "", //使用状态
      is_cancle: "", //核销状态 0 用户使用 1 扫码核销
      get_type: "", //领取方式
      type: "", //券类型
      title: "", //券类型
      page: "1",
      total_num: 0,
      tableData: [],
      formLabelWidth: "120px",
      dialogFormVisible: false,
      useStatus: [
        {
          value: "0",
          label: "未使用"
        },
        {
          value: "1",
          label: "已使用"
        }
      ],
      options: [
        {
          value: "0",
          label: "用户使用"
        },
        {
          value: "1",
          label: "扫码核销"
        }
      ],
      typeOptions: [
        {
          value: "0",
          label: "平台发放"
        },
        {
          value: "1",
          label: "用户领取"
        },
        {
          value: "2",
          label: "赠送"
        }
      ],
      ticketOption: [
        {
          name: "满减券",
          value: "1"
        },
        // {
        //   name: "折扣券",
        //   value: "2"
        // },
        {
          name: "代金券",
          value: "3"
        },
        {
          name: "兑换券",
          value: "4"
        }
        // {
        //   name: "储值券",
        //   value: "5"
        // },
        // {
        //   name: "通用券",
        //   value: "6"
        // },
        // {
        //   name: "次数券",
        //   value: "7"
        // }
      ],
      optionData: [
        // {
        //   name: "批量延期",
        //   icon: "el-icon-setting",
        //   value: "4"
        // },
        {
          name: "批量作废",
          icon: "el-icon-delete",
          value: "5"
        },
        {
          name: "批量暂停",
          icon: "el-icon-video-pause",
          value: "6"
        },
        {
          name: "批量开启",
          icon: "el-icon-video-play",
          value: "8"
        }
      ],
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      dateValue: [], //消费时间
      timeValue: [],
      cardData: [
        {
          name: "领券数量",
          unit: "张",
          use1: "",
        },
        {
          name: "使用数量",
          unit: "张",
          use1: "",
        },
        {
          name: "使用率",
          unit: "%",
          use1: ""
        }
      ],
      timeType: [
        {
          name: "今日",
          value: "1"
        },
        {
          name: "本周",
          value: "2"
        },
        {
          name: "本月",
          value: "3"
        }
      ],
      couponData: [],
      couponName: "", //优惠券名称筛选
      multipleSelection: [],
      statistics: "",
      pageStatus: false,
      showTime: false,
      postponeForm: {
        is_term: "0",
        date1: [],
        date2: "",
        coupon_ids: ""
      }
    };
  },
  mounted() {
    this.searchCoupon();
    if (this.$route.query.couponId) {
      // 单个优惠券筛选
      this.couponName = this.$route.query.couponId;
      this.pageStatus = true;
    }
    this.getLists();
  },
  methods: {
    radiogroup(val) {
      console.log(val);
      if (val == 1) {
        let strat = new Date(
          new Date().getFullYear() +
            "-" +
          (new Date().getMonth()+1) +
            "-" +
            new Date().getDate() +
            " " +
            "00:00:00"
        );
        let end = new Date(
          new Date().getFullYear() +
            "-" +
          (new Date().getMonth()+1) +
            "-" +
            new Date().getDate() +
            " " +
            "23:59:59"
        );
        console.log(time(strat),time(end))
        this.dateValue = [time(strat), time(end)];
      }
      if (val == 3) {
        var now = new Date(); //当前日期
        var nowMonth = now.getMonth(); //当前月
        var nowYear = now.getFullYear(); //当前年
        //本月的开始时间
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        //本月的结束时间
        var monthEndDate = new Date(nowYear, nowMonth + 1, 0);
        console.log(monthStartDate, monthEndDate);
        this.dateValue = [time(monthStartDate), time(monthEndDate)];
      }
      if (val == 2) {
        var weekStart = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - new Date().getDay() + 1
        );
        var weekEnd = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + (7 - new Date().getDay())
        );
        console.log(weekStart, weekEnd);
        this.dateValue = [time(weekStart), time(weekEnd)]
      }
    },
    // 延期
    postPhone(row) {
      this.postponeForm.date1 = [];
      this.postponeForm.date1.push(row.start_time.split(" ")[0]);
      this.postponeForm.date1.push(row.end_time.split(" ")[0]);
      this.postponeForm.coupon_ids = row.id;
      console.log("shuju ", row, this.postponeForm);
      this.showTime = true;
    },
    // 延迟弹窗
    closePostPhone() {
      this.showTime = false;
      this.postponeForm = {
        date1: [],
        coupon_ids: ""
      };
    },
    confirmPostPhone() {
      // 延期
      let data = {
        token: this.token,
        app_id: this.app_id,
        coupon_ids: this.postponeForm.coupon_ids,
        start_time: this.postponeForm.date1[0],
        end_time: this.postponeForm.date1[1],
        type: 0
      };
      couponPostponeUser(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.warning(res.msg);
        }
        this.showTime = false;
        this.postponeForm = {
          date1: [],
          coupon_ids: ""
        };
        console.log("延期", res);
        this.getLists();
        // this.tableData = res.data.result;
      });
    },

    //优惠券
    searchCoupon() {
      console.log("screenInput", this.screenInput);
      let data = {
        token: this.token,
        app_id: this.app_id,
        type: this.screenInput,
        store_id: 0 //
      };
      couponList(data).then(res => {
        console.log("订单列表", res);
        this.couponData = res.data.result;
      });
    },
    //多选
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.multipleSelection = val;
      console.log("数据多选，", val);
    },
    // 跳转
    go(type) {
      switch (type) {
        case "1":
          this.$router.push("optionTicket");
          break;
        case "2":
          this.$router.push("discounts");
          break;
        case "3":
          this.$router.push("grant");
          break;
        case "4":
          // 批量延期
          this.batchCoupon(4);
          break;
        case "5":
          // 批量刪除
          this.batchCoupon(5);
          break;
        case "6":
          // 批量暂停
          this.batchCoupon(6);
          break;
        case "8":
          // 批量开启
          this.batchCoupon(8);
          break;
        case "7":
          this.$router.push("statisticsCoupon");
          break;
      }
    },
    // 暂停
    batchCoupon(status) {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要操作的优惠券！！");
      } else {
        let ids = [];
        this.multipleSelection.forEach(item => {
          ids.push(item.id);
        });
        if (status == 4) {
          //  批量延期
          this.showTime = true;
        } else if (status == 5) {
          // 删除
          this.deleteTicks(ids.join(","));
        } else if (status == 6) {
          // 暂停1
          this.shop(1, ids.join(","));
        } else if (status == 8) {
          // 开启0
          this.shop(0, ids.join(","));
        }
      }
    },
    deleteTicks(ids) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 0, //
        coupon_ids: ids,
        type: 0
      };
      this.$confirm("作废是不可逆的，请谨慎作废?！！！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          couponCancle_expser(data).then(res => {
            console.log("shanchu ", res);
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.reload();
            } else {
              this.$message("作废失败");
            }
          });
          this.getLists();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消作废"
          });
        });
    },
    shop(is_stop, coupon_ids) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        is_stop: is_stop,
        coupon_ids: coupon_ids,
        type: "0"
      };
      couponShopUser(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.warning(res.msg);
        }
        console.log("暂停result", res);
        this.getLists();
        // this.tableData = res.data.result;
      });
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `adSign`
      });
    },
    // 筛选page
    screen() {
      this.page = 1;
      this.getLists();
    },
    // 记录
    getLists() {
      this.loading = true;
      let data = {
        app_id: this.app_id,
        page: this.page,
        // is_cancle: this.is_cancle,
        // get_type: this.get_type
        // type: this.type,
        // statistics: this.statistics
      };
      if (this.couponName != "") {
        data.coupon_id = this.couponName;
      }
      if (this.get_type != "") {
        data.get_type = this.get_type;
      }
      if (this.dateValue !== null && this.dateValue.length !== 0) {
        if (this.dateValue[0] != null) {
          data.start_time = this.dateValue[0]
          data.end_time = this.dateValue[1]
        }
      }
      if (this.is_used != "") {
        data.is_used = this.is_used;
      }
      coupon_indexs(data).then(res => {
        this.loading = false;
        console.log("sss", res);
        if (res.code == 200) {
          this.tableData = res.data.result;
          this.tableData.forEach(item => {
            // if(item.coupon_type)
            switch (item.coupon_type) {
              case 1:
                item.coupon = "满减券";
                break;
              // case 2:
              //   item.coupon = "折扣券";
              //   break;
              case 3:
                item.coupon = "代金券";
                break;
              case 4:
                item.coupon = "兑换券";
                break;
              default:
                item.coupon = "";
                break;
            }
            item.isShop =
              item.is_stop == 0 || item.is_stop == null ? "开启" : "暂停";
            item.exp = item.is_exp ? "已过期" : "未过期";
            item.used = item.is_used ? "已使用" : "未使用";
            item.use_time = item.is_used ? item.use_time : "";
          });
          this.total_num = res.data.total_num;
          this.cardData[0].use1 = res.data.tongji.T1count; //领券数量
          this.cardData[1].use1 = res.data.tongji.Tcount_use; //使用数量
          this.cardData[2].use1 = res.data.tongji.current_rate; //使用率
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    },
    // 导出
    exportList() {
      var data = {
        token: this.token,
        Api: "coupon/agent.coupon_data/coupon_statistics_export",
        params: [
          { name: "app_id", value: this.app_id },
          { name: "is_used", value: "1" },
          // { name: "is_cancle", value: this.is_cancle },
          { name: "get_type", value: this.get_type }
        ]
      };
      console.log(data);
      exportMethod(data);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  min-width: 900px;
  border: node;
  height: 100%;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
    .header {
      margin-bottom: 20px;
      .box {
        min-width: 330px;
        .title {
          min-width: 100px;
          text-align: right;
        }
        .fixedwidth {
          width: 180px;
          display: flex;
          justify-content: space-between;
        }
        ::v-deep .el-date-editor {
          width: 128px;
        }
      }
      .show {
        display: flex;
        justify-content: space-between;
        .box-card {
          width: 100%;
        }
        .num {
          font-size: 22px;
          font-weight: 550;
          color: #3377ff;
        }
      }
    }
    .bottom {
      flex: 1;
    }
    .page {
      height: 50px;
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 0px;
}
.el-table td {
  // padding: 12px 0;
}
</style>
